class WhyCustomersAccordion extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('[data-accordion-item]')];
    this.sectionRoot = this.closest('.why-customers-love-us');

    if (!this.items.length) return;

    this.items.forEach((item) => {
      const trigger = item.querySelector('[data-accordion-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', () => this.onTriggerClick(item));
    });

    const openItem = this.items.find((item) => item.classList.contains('is-open'));
    if (openItem) {
      this.updateMedia(openItem);
    }
  }

  onTriggerClick(item) {
    const isOpen = item.classList.contains('is-open');

    if (isOpen) {
      this.setItemOpen(item, false);
      return;
    }

    this.items.forEach((other) => {
      if (other !== item && other.classList.contains('is-open')) {
        this.setItemOpen(other, false);
      }
    });

    this.setItemOpen(item, true);
  }

  setItemOpen(item, open) {
    const trigger = item.querySelector('[data-accordion-trigger]');
    const panel = item.querySelector('[data-accordion-panel]');
    item.classList.toggle('is-open', open);
    trigger?.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel?.setAttribute('aria-hidden', open ? 'false' : 'true');

    if (open) {
      this.updateMedia(item);
      return;
    }

    const stillOpen = this.items.find((other) => other.classList.contains('is-open'));
    if (stillOpen) {
      this.updateMedia(stillOpen);
    } else {
      this.clearMedia();
    }
  }

  updateMedia(item) {
    const blockId = item.dataset.blockId;
    if (!this.sectionRoot || !blockId) return;

    this.sectionRoot.querySelectorAll('[data-accordion-media-item]').forEach((mediaItem) => {
      const isActive = mediaItem.dataset.blockId === blockId;
      mediaItem.classList.toggle('is-active', isActive);
      mediaItem.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }

  clearMedia() {
    if (!this.sectionRoot) return;

    this.sectionRoot.querySelectorAll('[data-accordion-media-item]').forEach((mediaItem) => {
      mediaItem.classList.remove('is-active');
      mediaItem.setAttribute('aria-hidden', 'true');
    });
  }
}

if (!customElements.get('why-customers-accordion')) {
  customElements.define('why-customers-accordion', WhyCustomersAccordion);
}
